


import { Routes, RouterModule } from '@angular/router';
import { TemplateInstanceComponent } from './templateinstance.component';

const routes: Routes = [
    {
        path: '',
        component: TemplateInstanceComponent
    },
];

export const TemplateInstanceRoutes = RouterModule.forChild(routes);
